exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/fulfillment.release/src/app/storage-place/container/container.component.css
// module id = ../../../../../src/app/storage-place/container/container.component.css
// module chunks = 0